import { BASE_URL } from './BaseUrl'
import { POSTS } from './Resources'
import HandleRequest from './HandleRequest'

export default function PostsApi(parameters) {
  return HandleRequest(BASE_URL, POSTS, parameters)
}
